import isEmail from 'validator/lib/isEmail';

/**
 * Retrieves the preferred language setting from local storage.
 *
 * @returns {string} The language code stored in local storage, or 'es' if not set.
 */
export const getLanguage = () => {
  return localStorage.getItem('language') ?? 'es';
};

/**
 * Checks if the provided email is a valid email address.
 *
 * @param {string} email - The email address to validate.
 * @returns {boolean} - Returns true if the email is valid, otherwise false.
 */
export const isValidEmail = (email) => {
  return typeof email === 'string' && isEmail(email);
};
